import { Directive } from '@angular/core';
import { AppContext } from '@farris/devkit';
import { DatagridComponent } from '@farris/ui-datagrid';
import { AbstractEndEdit } from './abstract_end_edit';

@Directive({
  selector: '[farris-grid-end-edit]'
})
class FarrisDataGridEndEditDirective extends AbstractEndEdit {
  constructor(protected appContext: AppContext, private datagrid: DatagridComponent) {
    super(appContext);
  }
  /**
   * ç»æç¼è¾
   * @param message message
   */
  public endEdit(message: any) {
    if (this.datagrid && typeof this.datagrid.endCellEdit === 'function') {
      this.datagrid.endCellEdit();
    }
  }
}
export { FarrisDataGridEndEditDirective };
